/* Copyright (c) 2022, VRAI Labs and/or its affiliates. All rights reserved.
 *
 * This software is licensed under the Apache License, Version 2.0 (the
 * "License") as published by the Apache Software Foundation.
 *
 * You may not use this file except in compliance with the License. You may
 * obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 */

import { useContext } from "react";
import { AccessDeniedPopupContext } from "../../contexts/AccessDeniedContext";
import { LayoutModalContent } from "./layoutModal";

export const AccessDeniedModal = () => {
	const context = useContext(AccessDeniedPopupContext);

	if (context === undefined) {
		throw new Error("Access denied modal must be used within the AccessDeninedContext.");
	}

	if (context.isPopupVisible === false) {
		return <></>;
	}

	return (
		<LayoutModalContent
			hideBackDrop={false}
			header={<h2>Access Denied</h2>}
			onClose={() => {
				context.hidePopup();
			}}>
			<p>{context.popupMessage}</p>
		</LayoutModalContent>
	);
};
